<template>
    <div>
        <h1>Mes passerelles
            <b-button to="/gateway/form">Ajouter</b-button>
        </h1>
        <b-row class="justify-content-center">
            <b-col cols="12" sm="10" md="8" ld="6">
                <p class="text-info" v-if="loading === false && gateways.length === 0">Aucune passerelle n'est actuellement enregistrée sur votre compte,
                    <router-link to="/gateway/form">ajoutez-en une</router-link>
                    dès maintenant.
                </p>
                <b-table v-if="loading || gateways.length" :fields="fields" :items="gateways" primary-key="id" striped hover head-variant="light" :busy="loading">
                    <template v-slot:table-busy>
                        <div class="text-center text-danger my-2">
                            <b-spinner class="align-middle"/>
                             <strong>Chargement des données…</strong>
                        </div>
                    </template>
                    <template v-slot:cell(status)="data">
                        <status-summary :show-icons="true" :show-text="false" :statuses="data.item.statusSummary"/>
                    </template>
                    <template v-slot:cell(action)="data">
                        <router-link :to="{name: 'gatewayEdit', params: {id: data.item.id}}">
                            <font-awesome-icon icon="edit" class="mr-2"/>
                        </router-link>
                        <router-link :to="{name: 'gatewayDetails', params: {id: data.item.id}}">
                            <font-awesome-icon icon="info-circle"/>
                        </router-link>
                    </template>
                </b-table>
            </b-col>
        </b-row>
    </div>
</template>

<script>
    import axios from "axios";
    import {API_URL, REFRESH_FREQUENCY} from "../../variables";
    import StatusSummary from "../StatusSummary";

    function updateData() {
        axios
            .get(API_URL + "/user/gateways")
            .then(response => {
                this.gateways = response.data;
                this.loading = false;
                this.timeout = window.setTimeout(() => updateData.call(this), REFRESH_FREQUENCY * 1000);
            });
    }

    export default {
        name: "Gateways",
        components: {
            StatusSummary
        },
        data() {
            return {
                fields: [
                    {key: "serial", label: "Numéro de série"},
                    {key: "label", label: "Intitulé"},
                    {key: "status", label: "État", class: "text-center"},
                    {key: "action", label: "Actions", class: "text-center"}
                ],
                gateways: [],
                loading: true,
                timeout: null
            }
        },
        mounted() {
            updateData.call(this);
        },
        beforeDestroy() {
            window.clearTimeout(this.timeout);
        }
    }
</script>

<style scoped>

</style>